import { useCallback } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import BarChart, { BarChartItem } from "@components/BarChart/BarChart";
import { HomeRankingTabEnum } from "@enums";
import { getValueWithSign } from "@helpers";
import "./MenuPenetrationChart.styles.scss";

interface Props {
    data: BarChartItem[];
    rankingTab: HomeRankingTabEnum;
}

const GROWTH_SCALE_EXPONENT = 0.5;

const MenuPenetrationChart: FCX<Props> = ({
    data,
    rankingTab,
    className,
}) => {
    const isGrowth = rankingTab === HomeRankingTabEnum.WHATS_GROWING;

    const formatValue = useCallback(
        (value: number): string => isGrowth
            ? `${getValueWithSign(Math.round(value))}%`
            : `${Math.round(value)}%`,
        [isGrowth],
    );

    return (
        <div className={cn("MenuPenetrationChart", className)}>
            <BarChart
                className="MenuPenetrationChart__chart"
                data={data}
                formatValue={formatValue}
                valueScaleExponent={isGrowth ? GROWTH_SCALE_EXPONENT : 1}
            />
        </div>
    );
};

export default MenuPenetrationChart;
